import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--clr-bg);
  color: var(--clr-sec);
  text-align: center;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 6rem;
  margin-bottom: 1rem;
  color: var(--clr-purple);
  font-weight: var(--fw-bold);
`;

const Message = styled.h2`
  font-size: var(--fs-h2);
  margin-bottom: 1rem;
  font-weight: var(--fw-reg);
`;

const Description = styled.p`
  font-size: var(--fs-body);
  color: var(--clr-sec);
  margin-bottom: 2rem;
  max-width: 500px;
`;

const Button = styled.button`
  background: var(--clr-purple);
  color: var(--clr-sec);
  border: none;
  padding: 0.75rem 2rem;
  font-size: var(--fs-body);
  border-radius: 4px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  font-family: var(--ff-primary);
  
  &:hover {
    opacity: 0.8;
  }
`;

const NotFound = () => {
  const history = useHistory();

  useEffect(() => {
    document.title = '404 - Page Not Found | VentScape';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'The page you are looking for could not be found. Return to VentScape to share your thoughts anonymously.');
    }
    
    const metaRobots = document.querySelector('meta[name="robots"]');
    if (!metaRobots) {
      const robots = document.createElement('meta');
      robots.name = 'robots';
      robots.content = 'noindex, follow';
      document.head.appendChild(robots);
    } else {
      metaRobots.content = 'noindex, follow';
    }
    
    return () => {
      document.title = 'VentScape';
      if (metaDescription) {
        metaDescription.setAttribute('content', 'VentScape - Share your thoughts anonymously');
      }
      const addedRobots = document.querySelector('meta[name="robots"]');
      if (addedRobots && !metaRobots) {
        addedRobots.remove();
      }
    };
  }, []);

  return (
    <Container>
      <Title>404</Title>
      <Message>Page Not Found</Message>
      <Description>
        Sorry, we couldn't find the page you're looking for. 
        It may have been moved, deleted, or never existed. 
        Let's get you back to VentScape.
      </Description>
      <Button onClick={() => history.push('/')}>
        Return to VentScape
      </Button>
    </Container>
  );
};

export default NotFound;